<template>
  <div class="MobileContent">
    <!-- header -->
    <header class="topHeader">
      <img class="logonSvg" src="@/assets/logo.svg" alt="" />
      <img
        class="clicksvg"
        v-if="showHeaderSvg"
        @click="showHeaderSvg = !showHeaderSvg"
        src="@/assets/close.svg"
        alt=""
      />
      <img
        class="clicksvg"
        v-else
        @click="showHeaderSvg = !showHeaderSvg"
        src="@/assets/Deployment.svg"
      />
      <transition name="move2">
        <div
          class="bottomcontent"
          @touchmove.prevent
          v-if="showHeaderSvg"
          ref="bottomcontent"
        >
          <div class="cenji">
            <div
              class="iteminfo"
              @click="goinfoba(item.href)"
              v-for="item in aList"
            >
              <div class="title">{{ item.title }}</div>
              <img src="@/assets/youjiantou.svg" alt="" />
            </div>
          </div>
        </div>
      </transition>
    </header>
    <div style="height: 1.2rem"></div>
    <!-- 第一屏 -->
    <div class="FirstScreen" id="FirstScreen">
      <img class="Subtract" src="@/assets/Subtract.svg" alt="" />
    </div>
    <!-- 品牌介绍 -->
    <div class="Brand" id="BrandIntroduction">
      <div class="BrandTitle">品牌介绍</div>
      <div class="BrandNavContent">
        <div
          class="BrandIteminfo"
          @click="navitem(index)"
          v-for="(item, index) in navlistinfo"
        >
          <div
            :style="{
              color: defaultindex == index ? '#6FBA2C' : '',
              fontSize: defaultindex == index ? '0.28rem' : '0.26rem',
            }"
          >
            {{ item }}
          </div>
          <div class="branLine" v-if="defaultindex == index"></div>
        </div>
      </div>
      <div class="BrandCard">
        <div class="titleinfocard">{{ navList[defaultindex].title }}</div>
        <div class="pinfo">
          <p v-for="item in navList[defaultindex].list">
            <img v-if="item.src" class="svgimginfo" :src="item.src" alt="" />
            {{ item.context }}
          </p>
        </div>
      </div>
    </div>
    <!-- 企业文化 -->
    <div class="EnterpriseCulture" id="CoreCulture">
      <div class="enterbox">
        <div class="topOnetext">我们的核心文化</div>
        <div class="topTwobox">
          <img src="@/assets/caizi.png" alt="" />
          <div class="infotwo">
            崇尚“舍得”文化永持一颗乐观感恩之心，将一份健康的快乐，施与四方。
          </div>
        </div>
        <div class="centerImgbox">
          <div class="imgitem">
            <img src="@/assets/xin.png" alt="" />
            <div class="hexinjsolog">我们的核心竞争力</div>
            <div class="lvslogn">真品 真诚 真情</div>
          </div>
          <div class="imgitem">
            <img src="@/assets/lunzi.png" alt="" />
            <div class="hexinjsolog">我们的行动纲领</div>
            <div class="lvslogn">创新求变 谋事为先</div>
          </div>
          <div class="imgitem">
            <img src="@/assets/laotou.png" alt="" />
            <div class="hexinjsolog">我们的使命</div>
            <div class="lvslogn">传播健康 造福民众</div>
          </div>
          <div class="imgitem">
            <img src="@/assets/shou.png" alt="" />
            <div class="hexinjsolog">我们的愿景</div>
            <div class="lvslogn">成为中国家庭首选</div>
            <div class="lvslogn">健康管理第一品牌</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资质荣誉 -->
    <div class="QualificationContext" id="qualification">
      <div class="Qualificationbox">
        <div class="toptitle">
          <div>公司及旗下分子公司</div>
          <div>历年来获得的部分荣誉或资质</div>
        </div>
        <div class="Quanitem" v-for="item in qualificationList">
          <div class="dateinfo">{{ item.date }}</div>
          <div class="context">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <!-- 加入我们 -->
    <div class="JoinUs" id="JoinUs">
      <div class="title">加入我们</div>
      <div class="navcontent" ref="navcontent">
        <div
          class="item"
          @click="joninclick(item.title, index)"
          v-for="(item, index) in joinUsList"
          :style="{ color: index == joninindex ? '#6FBA2C' : '' }"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="mainJoincard">
        <div class="title">{{ defaultTitle }}</div>
        <template v-for="(item, index) in LlisInfo[joninindex]">
          <div class="maintext">
            <div class="zice">{{ item.title }}</div>
            <div class="dunluo">
              <p class="dutyitem" v-for="item2 in item.list">
                {{ item2.matter }}
              </p>
            </div>
          </div>
        </template>
        <div class="mail">投递邮箱：hr@jjlg.net</div>
      </div>
      <div class="PhotoWall" @click="shouwinf = true"></div>
      <div class="maskPhoto" @click="shouwinf = false" v-if="shouwinf">
        <div class="maksbox" @click.stop="">
          <swiper>
            <swiper-slide v-for="item in AllPhotoWallList">
              <img class="imgmask" :src="item.url" alt="" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!-- 商城 -->
    <div class="shopContent" id="JumpShop"></div>
    <!-- 版权信息 -->
    <div class="CopyrightInformation">
      <a :href="jingshiyaowang" target="_blank">京食药网食备202120050</a>
      <a :href="shipinjingying" target="_blank"
        >食品经营许可证编号：JY11106183125343</a
      >
      <a :href="yiliaoqixie" target="_blank"
        >医疗器械经营备案号：京丰食药监械经营备20150001号</a
      >
      <a :href="hulianwang" target="_blank"
        >药品医疗器械信息服务备案：(京)网药械信息备字(2025)第00210号</a
      >
      <a style="margintop: 0.26rem"
        >©2007-{{ currentYearInfo }} 家家乐购（北京）科技有限公司 -</a
      >
      <a href="http://beian.miit.gov.cn/" target="_blank">京ICP备08006683号</a>
      <a>京公网安备 11010602100198号</a>
      <!-- <a>本网站用字经北京北大方正电子有限公司授权许可</a> -->
      <div class="banner_footerImg">
        <a
          href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202011062300006"
          target="_blank"
        >
          <img src="@/assets/image2.png" alt="" />
        </a>
        <a :href="yingyezhizhao" target="_blank">
          <img class="rightimg" src="@/assets/image1.png" alt="" />
        </a>
      </div>
    </div>
    <div style="height: 0.6rem"></div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, nextTick } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { handelYear } from "./Hooks/useCurrentYear";
const { currentYearInfo } = handelYear();

const showHeaderSvg = ref(false);
const bottomcontent = ref(null);
const defaultindex = ref(0);
let shipinjingying = require("@/assets/Certificat/shipinjingying.jpg");
let hulianwang = require("@/assets/Certificat/hulianwang.jpg");
let jingshiyaowang = require("@/assets/Certificat/jingshiyaowang.jpg");
let yiliaoqixie = require("@/assets/Certificat/yiliaoqixie.png");
let yingyezhizhao = require("@/assets/Certificat/yingyezhizhao.jpg");
const navitem = (index) => {
  defaultindex.value = index;
};
const AllPhotoWallList = [
  { url: require("@/assets/zhaopq/i1.jpg") },
  { url: require("@/assets/zhaopq/i2.jpg") },
  { url: require("@/assets/zhaopq/i3.jpg") },
  { url: require("@/assets/zhaopq/i4.jpg") },
  { url: require("@/assets/zhaopq/i5.jpg") },
  { url: require("@/assets/zhaopq/i6.jpg") },
  { url: require("@/assets/zhaopq/i7.jpg") },
  { url: require("@/assets/zhaopq/i8.jpg") },
  { url: require("@/assets/zhaopq/i9.jpg") },
  { url: require("@/assets/zhaopq/i10.jpg") },
  { url: require("@/assets/zhaopq/i11.jpg") },
];
const onSwiper = (swiper) => {
  console.log(swiper);
};
const onSlideChange = () => {
  console.log("slide change");
};
const navlistinfo = ref(["基本情况介绍", "业务发展情况", "业务未来展望"]);
const navList = reactive([
  {
    title: "公司基本情况介绍",
    list: [
      {
        context:
          "西藏家家乐购信息技术股份有限公司（以下简称公司）成立于2007年10月，注册地为拉萨市柳梧新区 国西藏家家乐购信息技术股份有限公司（以下简称公司）成立于2007年10月，注册地为拉萨市柳梧新区国际总部城，注册资本3366万。公司全资控股的子公司有10家，投资股权超过50%的子公司1家。子公司中包含1家国家高新技术企业，1家中关村科技园区高新技术公司。公司及旗下分子公司目前员工共计500余人。",
        src: require("@/assets/yidonduanlogo.png"),
      },
      {
        context:
          "公司主要所属行业为电子商务，主营业务为销售健康食品、医疗器械以及健康用品，并向消费者提供健康管理、健康咨询服务",
      },
      {
        context:
          " 公司的定位是成为领先的会员制健康产品销售及健康服务平台；公司的愿景是专注做中国家庭健康管理第一品牌",
      },
      {
        context:
          "公司及旗下分子公司的主要服务经营对象为有健康服务需求和健康产品购买需求的人群，公司的客户遍布全国各地，目前公司所服务的会员累计人数300余万人。",
      },
      {
        context:
          "公司及旗下分子公司从成立之初到现在，累计获得多个相关资质和荣誉。",
      },
    ],
  },
  {
    title: "公司业务发展情况",
    list: [
      {
        src: require("@/assets/mzxz.png"),

        context:
          "公司从成立至今，包括旗下分子公司累计向各地方税务机关及海关纳税总额过亿元，公司在主营业务的注册地连续多年被评定为A级纳税信用级别。",
      },
      {
        context:
          "公司及旗下分子公司成立之初主要是以电视和平面媒体进行客户引流并进行发展，随着业务发展和市场变化，公司及旗下分子公司逐渐从线下业务的经营模式转变为多渠道的业务经营模式，从而使公司业务更加灵活，未来发展空间更大。",
      },
      {
        context:
          "公司及旗下分子公司从成立之初代销几十种国内健康食品，目前发展到累计经营国内保健食品、医疗器械、传统滋补品百余种，跨境海外膳食营养补充剂、健康用品累计百余种，定制OEM产品十余种，公司正逐步利用自身稳定的供应链优势满足客户更多的健康需求。",
      },
      {
        context:
          "为了适应跨境业务的发展和提升客户满意度，公司及旗下分子公司从成立之初仅有一个自主运营的仓储中心，目前发展到涉及北京、河北、福州、深圳等多个产品中心仓，并在天猫、京东、唯品会、拼多多的体系下另行布局了十余个货物管理仓库。",
      },
      {
        context:
          "为了满足客户多样的个性化需求，适应公司业务多渠道的特性，并致力于整合公司业务流和数据流，公司为此组建了一个20余人的技术团队，为公司研发全套的客户管理、业务操作和分析系统，与此同时申报获取了几十个软件著作权。公司非常重视核心技术研发能力，并相信这是驱动公司快速发展的重要布局之一。",
      },
      {
        src: require("@/assets/mkf.png"),
        context:
          "在近年的经营发展中，公司发展培养建立了一个经验丰富的电商运营,团队，不仅使公司及旗下分子公司在天猫平台的品牌POP店运营到行业类目排名前列，并且还收到诸多大品牌店铺的青睐，2020-2021公司及旗下分子公司凭借很好的运营能力优势承接了年销量在8-10亿的几个品牌店铺的国内独家代理运营权，这将在未来给公司自身的线上业务发展带来更多的机会。",
      },
      {
        context:
          "为了满足客户多样的交互习惯，以及贯彻为客户一对一专业健康咨询服务的理念，公司在北京、山东、南京成立了多个客户服务中心，具备专业健康服务能力的客户服务专员人数达到几百余人。",
      },
    ],
  },
  {
    title: "公司业务未来展望",
    list: [
      {
        src: require("@/assets/yidonduanlogo.png"),
        context:
          "根据公司的业务规划，公司及旗下分子公司未来3-5年的产品品线将在现有基础上进行增加，新增产品线将涵盖儿童、孕妇、运动、轻食等多个领域；还将扩充百余种包含跨境电商健康产品在内的产品类目，逐步完善搭建以家庭为核心的全健康营养服务平台。",
      },
      {
        context:
          "公司将进一步扩大跨境电商业务版图，加强巩固供应链优势，计划再新增十余个全球产品一线供应商，以确保公司产品线按计划搭建。",
      },
      {
        context:
          "随着公司代运营业务不断的发展壮大，公司未来3-5年将新增会员200万人，从而也会增加相关健康服务专员及线上客服人员百余人。为了匹配公司的发展速度，进一步提升客户满意度和提升运营效率，公司将计划再设立多个货物仓储及发货管理中心，将确保其运营能力能有效覆盖全国。",
      },
    ],
  },
]);
const qualificationList = reactive([
  { date: "2011.03", content: "荣获“2010电商TOP50”客户价值管理奖。 " },
  {
    date: "2011.04",
    content:
      "荣获由商务部、亚太经济合作组织（APEC）主办“2011亚太电子商务绿色经济发展峰会暨第二届电子商务年会”优秀企业奖。",
  },
  { date: "2011.05", content: "荣获“易观”客户价值最佳管理奖。" },
  { date: "2014.12", content: "获国家高新技术企业资质。" },
  {
    date: "2015.06",
    content: "被列为北京市科技型中小企业创新基金政府支持项目 。",
  },
  { date: "2015.11", content: "荣登“2015快公司TOP100”的榜单 。" },
  { date: "2015.12", content: "被经济观察报评为“花蕾之约40强企业”。" },
  {
    date: "2016.01",
    content: "中关村移动互联网产业联盟评为2015年度最具潜力移动医疗APP。",
  },
  {
    date: "2016.01",
    content: "荣获2015年度中国互联网+创新奖之最佳媒体口碑奖。",
  },
  {
    date: "2016.02",
    content: "荣登第一届互联网医健年度风云榜之最受关注新锐企业榜。",
  },
  { date: "2016.05", content: "荣获2016年春季移动医疗APP黑马奖。" },
  { date: "2016.06", content: "荣登《中国企业家》2016最具成长性企业萌芽榜。" },
  { date: "2016.09", content: "荣获红鲱鱼2016年亚太科技企业100强。" },
  { date: "2016.11", content: "荣获红鲱鱼2016年全球科技企业100强 。" },
  { date: "2016.12", content: "荣获“未来医疗100强”荣誉称号 。" },
  { date: "2021.03", content: "荣获天猫国际最佳用户体验奖。" },
]);
const joinUsList = reactive([
  { title: "新媒体运营经理" },
  { title: "产品经理" },
  { title: "活动策划" },
  { title: "销售顾问" },
]);
const defaultTitle = ref("新媒体运营经理");
const joninindex = ref(0);
const navcontent = ref(null);
const joninclick = (title, index) => {
  switch (index) {
    case 0:
      navcontent.value.scrollLeft = 0;
      break;
    case 1:
      navcontent.value.scrollLeft = 26;

      break;
    case 2:
      navcontent.value.scrollLeft = 50;

      break;
    case 3:
      navcontent.value.scrollLeft = 999;

      break;
    default:
      console.log("default");
      break;
  }
  defaultTitle.value = title;
  joninindex.value = index;
};
const LlisInfo = [
  [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "1、搭建微信公众号、小红书、今日头条的运营工具矩阵。搭建起相匹配的产品、内容、活动、会员增长、服务为联动的的运营策略规划。分析同行业的媒体热点以及内容，研究用户喜好调整优化；提高粉丝量，增加用户粘性；",
        },
        {
          matter:
            "2、负责平台日常内容输出、粉丝互动管理等工作（活动运营、热点话题、爆文运营等）策划产品活动，输出文案，把控微信公众号、小红书、今日头条等推动渠道工作执行企业账号运营管理，提高用户增长和引流转化等工作；",
        },
        {
          matter: "3、建立公司内容资料库，整理产品文案定期更新，并与粉丝互动；",
        },
        {
          matter: "4、完成领导安排的其他事务。",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter:
            "1、本科以上学历，有0-1搭建新媒体平台，包括今日头条、微信公众号、小红书、抖音等运营整体思路;网感好、选题策划能力强、擅长数据分析、有涨粉、转化逻辑，了解多个新媒体平台运营规则；",
        },
        {
          matter:
            "2、优秀的沟通能力、团队管理及协作能力、执行力、有耐心、抗压能力强、思维活跃、有亲和力、了解中老年用户心理；",
        },
        {
          matter: "3、有保健品类、美妆类行业经验，食品营养学专业者优先。",
        },
      ],
    },
  ],
  [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "根据客户需求，市场热点寻找或定制相关产品，并对产品的生命周期进行管理。",
        },
        {
          matter:
            "1、能及时收集中老年保健品，家用医疗器械市场信息，洞察市场热点。",
        },
        {
          matter: "2、调研客户需求，能够打造爆品，挖掘潜力趋势单品。",
        },
        {
          matter:
            "3、负责供应商的维护和管理，能够与供应商的接洽、谈判，控制采购费用、降低采购成本，争取供应商的产品价格支持；",
        },
        {
          matter:
            "4、熟悉中老年市场信息，洞察客户需求，分析用户需求变化，流量结构变化，探索保健品创新型营销方案，最大化满足客户的需求；",
        },
        {
          matter:
            "5. 关注市场商品价格变化，及时更换组合，调整价格策略，及时了解、收集并反馈市场信息；",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter: "1. 本科及以上学历，三年以上相关行业和品类的采购经验；",
        },
        {
          matter: "2. 熟悉产品管理运作流程；",
        },
        {
          matter:
            "3. 熟悉中老年保健市场供应链，对传统滋补品产品熟知，具备丰富的行业及品牌资源优先；",
        },
        {
          matter: "4. 具有洞察消费者需求的能力。",
        },
      ],
    },
  ],
  [
    {
      title: "【岗位职责】",
      list: [
        {
          matter: "1、熟悉会员管理体系，会员分层管理，会员全生命周期管理；",
        },
        {
          matter:
            "2、熟练掌控会员数据分析方法，可以根据现有会员数据进行活动效果分析；",
        },
        {
          matter:
            "3、熟悉会员活动策划，可以根据会员的现状特点针对性的制定会员拉新、留存、促活、裂变等的相关活动，为会员全生命周期贡献和会员中心总产出负责；",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter: "1、本科及以上学历，两年及以上活动策划工作经验；",
        },
        {
          matter:
            "2、有同行业工作经验，或有连锁零售行业活动策划、会员管理经验的优先；",
        },
        {
          matter:
            "3、沟通表达能力佳，有较强的工作责任心，吃苦耐劳，具备良好的执行力和团队合作精神。",
        },
      ],
    },
  ],
  [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "1、根据公司产品内容运营方向和运营需求，负责公司产品宣传册、营销海报、软文内容策划和文案输出；",
        },
        {
          matter:
            "2、从客户及消费者的角度出发，深挖产品卖点，以文案形式展示优点，提示产品核心竞争力，协同设计完成产品详情描述;",
        },
        {
          matter:
            "3、结合行业热点和公司产品优势、客户案例输出具有感染力的内容；",
        },
        {
          matter: "4、根据每月营销节奏，提供活动页面文案排版及输出；",
        },
        {
          matter:
            "5、熟悉产品策划方法，对于产品卖点挖掘、目标人群痛点选定、同类竞品分析等有一套成熟的工作方法",
        },
        {
          matter:
            "6、有一定文字功底，熟练掌握软、有创意、有逻辑、硬文的各种写作方法",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter:
            "1、专科及以上学历，两年以上内容运营经验，有保健品同行业工作经验，或有化装品、医美等行业的优先；",
        },
        {
          matter: "2、有撰写产品文案的经验中文、新闻学、广告学等相关专业背景；",
        },
        {
          matter: "3、优秀的创意能力和文字功底，敏锐的洞察力；",
        },
        {
          matter: "4、策划和文案能力，文字功底深厚，同时兼备良好的视觉审美；",
        },
        {
          matter: "5、熟悉内容运营模式，对文案撰写及内容营销充满激情； ",
        },
        {
          matter:
            "6、沟通表达能力佳，有较强的工作责任心，吃苦耐劳，具备良好的执行力和团队合作精神。",
        },
      ],
    },
  ],
  [
    {
      title: "【岗位职责】",
      list: [
        {
          matter:
            "1、负责回访会员意向客户，评估客户需求，根据对产品的了解，向客户有针对性介绍产品优势，为会员客户提供产品推荐和服务达成销售意向。协助并跟踪解决会员客户的售前、售后问题；",
        },
        {
          matter:
            "2、根据会员情况给予健康指导能够学会管理客户，与客户保持良好沟通促进客户再次复购转化；",
        },
        {
          matter:
            "3、记录和反馈客户意见，有效进行客户关系的维护和发展，提升客户满意度和客户价值，建立长期共赢的客户合作关系； ",
        },
        {
          matter: "4、能够有效挖掘客户需求，进行开发新客户。",
        },
      ],
    },
    {
      title: "【任职要求】",
      list: [
        {
          matter: "1、中专或高中以上学历，有一年以上电话销售工作经验者优先；",
        },
        {
          matter:
            "2、普通话标准，沟通表达能力、亲和力佳、有较强的抗压能力、责任心、良好的工作心态、具备良好的客户服务意识，执行力和团队合作精神；",
        },
        {
          matter: "3、从事医学营养健康行业工作者优先。",
        },
      ],
    },
  ],
];
const aList = [
  { title: "官网首页", href: "FirstScreen" },
  { title: "品牌介绍", href: "BrandIntroduction" },
  { title: "企业文化", href: "CoreCulture" },
  { title: "资质荣誉", href: "qualification" },
  { title: "加入我们", href: "JoinUs" },
  { title: "商城首页", href: "JumpShop" },
];
const goinfoba = (v) => {
  nextTick(() => {
    document.getElementById(v).scrollIntoView();
  });
  showHeaderSvg.value = false;
};
const shouwinf = ref(false);
</script>

<style lang="less" scoped>
@w: 6.98rem;
.MobileContent {
  width: 7.5rem;
  // overflow-y: scroll;
  overflow-x: hidden;
  // height: 1rem;
  // height: 100vh;
  .topHeader {
    width: 7.5rem;
    height: 1.2rem;
    background: #fff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    // background: orange;
    display: flex;
    z-index: 9999;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
    justify-content: space-between;
    position: fixed;
    left: 0;
    top: 0;
    .logonSvg {
      width: 2rem;
      height: 0.84rem;
    }
    .clicksvg {
      width: 0.44rem;
      height: 0.44rem;
    }

    .move2-enter-active,
    .move2-leave-active {
      transition: all 0.5s ease;
    }
    .move2-enter-from,
    .move2-leave-to {
      opacity: 0;
      // height: 0;
    }

    .bottomcontent {
      width: 7.5rem;
      height: calc(100vh - 1.2rem);
      background: rgba(255, 255, 255, 0.68);
      backdrop-filter: blur(15px);
      // background: yellowgreen;
      position: absolute;
      left: 0;
      top: 1.2rem;
      z-index: 98;
      // padding-left: 14px;
      box-sizing: border-box;
      transition: all 1s;
      .cenji {
        padding-left: 0.28rem;
        background: rgba(255, 255, 255, 0.68);
        backdrop-filter: blur(15px);
        .iteminfo {
          width: 7.22rem;
          height: 1.04rem;
          padding-right: 0.24rem;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(15px);
          display: flex;
          align-items: center;
          // padding-right: 12px;
          justify-content: space-between;
          box-sizing: border-box;
          border-bottom: 0.02rem solid #f5f5f5;
          color: #6c7169;
          font-size: 0.3rem;
          font-family: "PingFang SC";
        }
      }
    }
  }
  .FirstScreen {
    width: 7.5rem;
    height: 7.72rem;
    // background: yellow;
    background: url("../assets/Mbackgroundimg.png");
    background-size: cover;
    position: relative;
    .Subtract {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99;
      bottom: 0.44rem;
      animation: moveRight 2s linear infinite;
    }
    // animation: ;
    @keyframes moveRight {
      0% {
        bottom: 0.44rem;
        opacity: 1;
      }
      100% {
        opacity: 0;
        bottom: 0.55rem;
      }
    }
  }
  .Brand {
    width: @w;
    // background: orange;
    margin: 0 auto;
    .BrandTitle {
      color: #282b26;
      font-family: "PingFang SC";
      font-weight: 900;
      font-size: 0.38rem;
      text-align: center;
      margin-top: 0.6rem;
    }
    .BrandNavContent {
      margin-top: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 0.26rem;
      font-family: "PingFang SC";
      font-weight: 400;
      color: #282b26;
      .BrandIteminfo {
        position: relative;
        .branLine {
          width: 0.6rem;
          height: 0.06rem;
          background: #6fba2c;
          border-radius: 0.96rem;
          position: absolute;
          left: 50%;
          bottom: -0.1rem;
          transform: translateX(-50%);
        }
      }
    }
    .BrandCard {
      widows: @w;
      background: #ffffff;
      box-shadow: 0px 0px 0.08rem rgba(0, 0, 0, 0.25);
      border-radius: 0.38rem;
      margin-top: 0.32rem;
      padding: 0.6rem 0.38rem;
      box-sizing: border-box;
      .titleinfocard {
        color: #60635c;
        font-size: 0.32rem;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 700;
      }
      .pinfo {
        margin-top: 0.32rem;
        text-indent: 2em;
        font-size: 0.28rem;
        color: #6c7169;
        line-height: 0.54rem;
        letter-spacing: 0.02rem;
        .svgimginfo {
          width: 3.3rem;
          height: 1.92rem;
          margin-left: 0.3rem;
          float: right;
        }
      }
    }
  }
  .EnterpriseCulture {
    // background: yellowgreen;
    background: url("@/assets/shan.svg");
    margin-top: 0.8rem;
    // height: 11.7rem;
    background-size: cover;
    .enterbox {
      width: @w;
      margin: 0 auto;
      .topOnetext {
        color: #282b26;
        font-size: 0.36rem;
        font-weight: 900;
        margin-left: 0.2rem;
      }
      .topTwobox {
        margin-top: 0.3rem;
        margin-left: 0.5rem;
        width: 6.2rem;
        & > img {
          width: 4rem;
        }
        .infotwo {
          color: #6c7169;
          font-size: 0.28rem;
          margin-top: 0.24rem;
        }
      }
      .centerImgbox {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 0.3rem;
        .imgitem {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 0.4rem;
          & > img {
            width: 3.22rem;
            height: 3.22rem;
          }
          .hexinjsolog {
            color: #6c7169;
            font-size: 0.26rem;
          }
          .lvslogn {
            color: #6fba2c;
            font-size: 0.32rem;
            font-weight: 900;
            margin-top: 0.08rem;
          }
        }
      }
    }
  }
  .QualificationContext {
    // background: orange;
    background: url("@/assets/11.png");
    background-size: contain;
    background-position: bottom center;
    background-repeat: no-repeat;
    margin-top: 0.6rem;
    padding-bottom: 0.56rem;
    box-sizing: border-box;
    .Qualificationbox {
      width: @w;
      margin: 0 auto;
      .toptitle {
        width: 5rem;
        height: 1.08rem;
        color: #282b26;
        font-weight: 900;
        font-size: 0.38rem;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.3rem;
      }
      .Quanitem {
        width: @w;
        padding: 0.3rem 0.32rem 0.32rem 0.36rem;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 0.04rem 0.22rem rgba(70, 81, 60, 0.14);
        backdrop-filter: blur(0.3rem);
        border-radius: 0.38rem;
        margin-bottom: 0.24rem;

        .dateinfo {
          color: #6fba2c;
          font-size: 0.32rem;
          font-weight: 700;
        }
        .context {
          color: #6c7169;
          font-size: 0.28rem;
          font-weight: 400;
          margin-top: 0.1rem;
        }
      }
    }
  }
  .JoinUs {
    width: @w;
    margin: 0 auto;
    margin-top: 0.8rem;
    // overflow: hidden;
    & > .title {
      color: #282b26;
      font-size: 0.36rem;
      font-weight: 900;
      margin-left: 0.2rem;
    }
    .navcontent {
      // width: 3rem;
      margin-top: 0.3rem;
      margin-left: 0.6rem;
      // background: orange;
      display: flex;
      // height: 0.42rem;
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      // width: 8rem;
      .item {
        margin-right: 0.6rem;
        white-space: nowrap;
        font-size: 0.28rem;
        font-weight: 400;
      }
      // &::-webkit-scrollbar {
      //   width: 1px;
      // }
      // &::-webkit-scrollbar-thumb {
      //   width: 0px;
      // }
    }
    .mainJoincard {
      width: 7rem;
      padding: 0.6rem 0.36rem;
      box-sizing: border-box;
      border: 0.02rem solid #e0e0e0;
      border-radius: 0.38rem;
      margin-top: 0.3rem;
      box-shadow: 0px 0px 0.08rem rgb(0 0 0 / 14%);

      .title {
        color: #60635c;
        font-size: 0.36rem;
        font-weight: 700;
      }
      .maintext {
        .zice {
          margin-top: 0.43rem;
          color: #282b26;
          font-weight: 700;
          font-size: 0.32rem;
        }
        .dunluo {
          margin-top: 0.24rem;
          .dutyitem {
            color: #6c7169;
            font-size: 0.28rem;
            line-height: 0.54rem;
            letter-spacing: 0.01rem;
          }
        }
      }
      .mail {
        font-size: 0.28rem;
        color: #282a26;
        margin-top: 0.5rem;
      }
    }
    .PhotoWall {
      width: @w;
      height: 4.7rem;
      background: url("@/assets/PhotoWall.png");
      background-size: cover;
      margin-top: 0.3rem;
    }
    .maskPhoto {
      position: fixed;
      left: 0;
      top: 0;
      width: 7.5rem;
      height: 100vh;
      background: rgba(0, 0, 0, 0.6);
      z-index: 999999;
      .maksbox {
        width: 7.5rem;
        height: 6rem;
        background: #fff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        .swiper {
          // width: 7.5rem;
          width: 100%;
          height: 100%;
          .swiper-slide {
            width: 7.5rem;
            .imgmask {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  .shopContent {
    width: 7.5rem;
    height: 6.48rem;
    // background: yellowgreen;
    // background-size: cover;
    margin-top: 0.6rem;
    background: url("@/assets/shopbai.png");
    background-repeat: no-repeat;
    background-size: contain;
  }
  .CopyrightInformation {
    width: @w;
    margin: 0 auto;
    margin-top: 0.6rem;

    // background: orange;
    & > a {
      display: block;
      text-align: center;
      color: #282b26;
      font-size: 0.24rem;
      font-weight: 300;
      margin-top: 0.04rem;
    }
    .banner_footerImg {
      text-align: center;
      margin-top: 0.26rem;
      .rightimg {
        margin-left: 0.4rem;
      }
    }
  }
}
</style>
